function customVideoPlay(element) {
    var video = $(element).find('.custom-autoPlay-videoPlayer')[0];
    if (!video) return;
    if (typeof window.lazyLoadElement === 'function' && video.querySelector('source[data-src]')) {
        window.lazyLoadElement(video);
    }
    var btnId = $(element).find('.customVideoPlayButton').attr('id');
    videoPlayOrPause(video, btnId);
}

function customVideoPlayMobile(element) {
    var video = $(element).find('.custom-autoPlay-videoPlayer-mobile')[0];
    if (!video) return;
    if (typeof window.lazyLoadElement === 'function' && video.querySelector('source[data-src]')) {
        window.lazyLoadElement(video);
    }
    var btnId = $(element).find('.customVideoPlayButtonMobile').attr('id');
    videoPlayOrPause(video, btnId);
}

function videoPreventClick(e) {
    e.preventDefault();
}

function videoPlayOrPause(video, buttonId) {
    var videoButton = $("#" + buttonId);
    if (video.paused) {
        videoButton.fadeOut();
        video.play().catch(function(){});
        video.controls = true;
    } else {
        videoButton.fadeIn();
        video.pause();
        video.controls = false;
    }
}